'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  // getLBalanceSalariesUser(context, params = {}) {
  //   const defaultData = { rows: [], count: 0, team_member: []}
  //   return new Promise(async (resolve) => {
  //     try {
  //       const url = `${baseUrl}/v1/employeesalaries_users`
  //       const result = await axios.get(url, {
  //         ...costumHeader('Get Employee By Salaries', 4),
  //         params,
  //       })
  //       if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
  //       context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
  //       return resolve(defaultData)
  //     } catch (e) {
  //       context.dispatch('nShowMessage', {type: 'error', msg: e.message})
  //       return resolve(defaultData)
  //     }
  //   })
  // },
  getLBalanceListByGroup(context, params = {}) {
    const defaultData = { rows: [], count: 0, team_member: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/listbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get User List', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLCategory(context, params = {}) {
    const defaultData = { rows: [], count: 0}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leaveBalanceCompany`
        const result = await axios.get(url, {
          ...costumHeader('Get User List', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLBalanceListNoPagination(context, params = {}) {
    const defaultData = { rows: [], count: 0 }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/listbycompanyidnonpagination`
        const result = await axios.get(url, {
          ...costumHeader('Get User List', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLBalancePersonalDetail(context, params = {}) {
    const defaultData = {
      addresses: [],
      emergencyContacts: [],
      employeeDetails: {},
      employeeInformation: {},
      families: [],
      hisotyrSalary: [],
      historyMembership: [],
      historyTaxMethod: [],
      historyTaxStatus: [],
      workExperiences: [],
    }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/personaldetails`
        const result = await axios.get(url, {
          ...costumHeader('Get Personal Detail', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLBalanceByKeyword(context, params = {}) {
    const defaultData = { page: 1, pageSize: 0, records: [], total: 0, total_pages: 0 }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/listbykeyword`
        const result = await axios.get(url, {
          ...costumHeader('Get User By Keyword', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLBalanceByCompanyId(context, params = {}) {
    const defaultData = { all: [] }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/listallbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get User By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getLBalanceDetail(context, params = {}) {
    const defaultData = { group: { zones: [] }, schedule_users: [] }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/detail`
        const result = await axios.get(url, {
          ...costumHeader('Get User Detail', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveEmployeeData(context, body = {}) { // deprecated
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/add`
        const result = await axios.post(url, body, costumHeader('Save Employee', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveEmployeeInformation(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/user/add`
        const result = await axios.post(url, body,
          {
            ...costumHeader('Save Employee Information', 2), 
            validateStatus: () => true 
          })
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editEmployeeData(context, body = {}) { // deprecated
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/edit`
        const result = await axios.post(url, body, costumHeader('Edit Employee', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editEmployeeInformation(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/user/edit/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Employee Information', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteEmployeeAuth(context, body = {}) { //deprecated
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/deleteuserauth`
        const result = await axios.delete(url, body, costumHeader('Delete User Auth', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteEmployee(context, body = {}) { //deprecated
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/delete`
        const result = await axios.post(url, body, costumHeader('Delete User', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteEmployeeWorkingStatus(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/workingstatus/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Employee Working Status', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }